import type React from "react"
import { Link } from "react-router-dom"
import { Button } from "@/shared/components/ui/button"

const NotFound404: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-800">404</h1>
        <p className="text-2xl font-medium text-gray-600 mt-4">Page Not Found</p>
        <p className="text-gray-500 mt-2">The page you're looking for doesn't exist.</p>
        <Link to="/">
          <Button className="mt-6">Go Back Home</Button>
        </Link>
      </div>
    </div>
  )
}

export default NotFound404
